import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { dynamicImage } from "../utils";
import { routes } from "../routers/routes";
import SignInForm from "./SignInForm";
import { Image } from "../coreComponents/Image";
import ApiService from "../services/apiService";

const Auth = () => {
  const [projectData, setProjectData] = useState<any>([]);
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await ApiService.axiosApi(`/projectsettings/getallproject`, {
          method: 'GET'
        })
        if (response.success) {
         
          setProjectData(response.data.data[0].projectName)
        } else {
          console.log(response.message || response.status || "unable to get projects")
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    fetchProjects();
  }, [])

  if (loading) {
    return <div>loading.....</div>
  }

  return (
    <Container fluid className="p-0">
      <Row className="m-0" >
        <Col xs="12" className="p-0">
          <div className="login-card login-dark" >

            <div  className="">
              <div>
                <div className='text-lg-center' >
                  <h4 className="heading" style={{ fontSize: '35px', fontWeight: '600', fontFamily: 'Ysabeau, sans-serif', lineHeight: '42px' }}>{'Demo Application'}</h4>
                </div>
                
              </div>
             
                <div className="login-main" style={{ borderRadius: "0" }}>
                  <SignInForm />
                  
                </div>
              
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Auth;
